import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import * as React from 'react'

export default { ImportContactsIcon, React }